module.exports = __webpack_public_path__ + "img/LpnPickS1.7c2a13b7.png";